/**
 * Module name: ent
 * Description: This module contains CyberAudit-Web specific JavaScript logic.
 *
 * This module is bundled into a single minimized JS file found in: "/dist/ent.js".
 *
 * Notes:
 * 	- ES6 JavaScript is used in this bundle. This includes functionality like
 * 	  import/export statements, let/const keywords, arrow functions, and more.
 */

import {GlobalEntObj} from "./data/global-ent";
import {tryToSetupDebugMode} from "./data/constants";
import {setupData} from "./data/setup-data";
import {setupPage} from "./logic/setup-page";
import {setupExports} from "./data/setup-exports";

window.GlobalEnt = new GlobalEntObj();

document.addEventListener('DOMContentLoaded', function() {
    tryToSetupDebugMode();
    setupData();
    setupPage();
    setupExports();
});